import { useNavigate } from 'react-router-dom'

export default function Terms() {
  const navigate = useNavigate()
  return (
    <div style={s.page}>
      <button type="button" onClick={() => navigate(-1)} style={s.back}>← Volver</button>
      <h1 style={s.h1}>Términos y Condiciones de Uso — Bellason</h1>
      <p style={s.meta}>Última actualización: mayo 2026</p>

      <h2 style={s.h2}>1. Qué es Bellason</h2>
      <p style={s.p}>
        Bellason es una plataforma digital que conecta clientes que buscan servicios de
        belleza a domicilio con proveedoras de servicios en Hermosillo, Sonora, México.
        Bellason no presta los servicios de belleza directamente, solo facilita la conexión
        entre las partes.
      </p>

      <h2 style={s.h2}>2. Requisitos para usar la plataforma</h2>
      <ul style={s.ul}>
        <li>Ser mayor de 18 años.</li>
        <li>Proporcionar información verdadera al registrarse.</li>
        <li>Las proveedoras deben subir una fotografía de su INE vigente como requisito obligatorio para activar su cuenta. Una cuenta no verificada no puede hacer ofertas ni recibir leads.</li>
        <li>Un número de teléfono y correo electrónico por persona. No se permiten cuentas duplicadas.</li>
      </ul>

      <h2 style={s.h2}>3. Para clientes</h2>
      <ul style={s.ul}>
        <li>Publicar una solicitud es completamente gratuito.</li>
        <li>Al publicar, la solicitud estará visible para proveedoras durante 60 segundos. Pasado ese tiempo puede renovarse.</li>
        <li>El cliente puede ver el perfil completo de cada proveedora antes de aceptar una oferta, incluyendo fotos de trabajos anteriores, servicios y reseñas de otros clientes.</li>
        <li>Al aceptar una oferta, el cliente se compromete a recibir el servicio en la dirección indicada.</li>
        <li>Una vez que la proveedora presiona "Ya llegué", la solicitud queda bloqueada. El cliente debe liberar el pedido dejando una reseña al finalizar el servicio.</li>
        <li>No dejar reseña impide cerrar el servicio. Bellason puede cerrar el caso manualmente si hay disputa.</li>
      </ul>

      <h2 style={s.h2}>4. Para proveedoras</h2>
      <ul style={s.ul}>
        <li>El registro requiere foto de perfil, INE y datos de contacto reales.</li>
        <li>Al verificarse la cuenta, la proveedora recibe 5 leads gratuitos para comenzar.</li>
        <li>Cada lead tiene un costo de $35 MXN (1 crédito). La recarga mínima es de $140 MXN equivalente a 4 créditos.</li>
        <li>El crédito se descuenta únicamente cuando el cliente acepta la oferta de la proveedora, no antes.</li>
        <li>Los créditos no son reembolsables una vez que el lead fue aceptado y el contacto del cliente fue desbloqueado.</li>
        <li>La proveedora puede ganar 20 leads gratuitos adicionales demostrando que publicó Bellason en sus redes sociales. Esto requiere aprobación manual del administrador.</li>
        <li>La proveedora es responsable de presentarse en el domicilio del cliente en el tiempo acordado por WhatsApp.</li>
        <li>Proporcionar datos falsos, suplantar identidad o crear cuentas duplicadas resulta en bloqueo permanente.</li>
      </ul>

      <h2 style={s.h2}>5. Pagos</h2>
      <ul style={s.ul}>
        <li>Los pagos se procesan a través de Mercado Pago. Bellason no almacena datos de tarjetas.</li>
        <li>Una recarga exitosa suma créditos a la cuenta de forma inmediata una vez confirmada por Mercado Pago.</li>
        <li>En caso de fallo en el pago, los créditos no se suman hasta que el pago sea confirmado.</li>
        <li>Bellason no emite reembolsos por créditos ya utilizados en leads activos o completados.</li>
      </ul>

      <h2 style={s.h2}>6. Reseñas</h2>
      <ul style={s.ul}>
        <li>Solo clientes que completaron un servicio pueden dejar reseña.</li>
        <li>Las reseñas deben ser verídicas y referirse al servicio recibido.</li>
        <li>Bellason puede eliminar reseñas ofensivas, falsas o que violen estos términos.</li>
        <li>Las reseñas son definitivas. No se pueden editar una vez publicadas.</li>
      </ul>

      <h2 style={s.h2}>7. Conducta prohibida</h2>
      <p style={s.p}>Está prohibido para cualquier usuario:</p>
      <ul style={s.ul}>
        <li>Crear cuentas falsas o duplicadas.</li>
        <li>Usar la plataforma para actividades ilegales.</li>
        <li>Acosar, amenazar o engañar a otros usuarios.</li>
        <li>Compartir datos de contacto de clientes fuera de la plataforma con fines distintos al servicio acordado.</li>
        <li>Intentar evadir el sistema de créditos o manipular reseñas.</li>
      </ul>
      <p style={s.p}>El incumplimiento resulta en suspensión o bloqueo permanente sin derecho a reembolso de créditos restantes.</p>

      <h2 style={s.h2}>8. Responsabilidad</h2>
      <p style={s.p}>
        Bellason actúa como intermediario tecnológico. No es responsable de la calidad del
        servicio prestado, disputas entre usuario y proveedora, daños ocurridos durante la
        prestación del servicio, ni de información falsa proporcionada por cualquiera de
        las partes. Cada proveedora opera de forma independiente y es responsable de su
        trabajo.
      </p>

      <h2 style={s.h2}>9. Privacidad</h2>
      <p style={s.p}>
        Los datos personales recopilados (nombre, teléfono, correo, INE) se usan
        exclusivamente para operar la plataforma y verificar identidades. No se venden a
        terceros. La foto de INE se almacena de forma segura y solo es visible para el
        administrador de Bellason con fines de verificación.
      </p>

      <h2 style={s.h2}>10. Modificaciones</h2>
      <p style={s.p}>
        Bellason puede actualizar estos términos en cualquier momento. El uso continuo de
        la plataforma después de un cambio implica aceptación de los nuevos términos.
      </p>

      <h2 style={s.h2}>11. Contacto</h2>
      <p style={s.p}>
        Para dudas, disputas o reportes:{' '}
        <a href="mailto:soporte@bellason.mx" style={s.link}>soporte@bellason.mx</a>
      </p>

      <p style={{ ...s.p, fontStyle: 'italic', marginTop: 24, color: 'var(--bln-text-muted)' }}>
        Al registrarte en Bellason aceptas estos términos en su totalidad.
      </p>
    </div>
  )
}

const s = {
  page: { minHeight: '100vh', background: 'var(--bln-bg)', color: 'var(--bln-text)', maxWidth: 720, margin: '0 auto', padding: '24px 18px 60px', fontFamily: 'system-ui, sans-serif', lineHeight: 1.6 },
  back: { background: 'none', border: 'none', color: 'var(--bln-accent)', cursor: 'pointer', fontSize: 14, padding: 0, marginBottom: 16 },
  h1: { fontSize: 24, fontWeight: 800, color: 'var(--bln-text)', marginBottom: 4 },
  meta: { fontSize: 12, color: 'var(--bln-text-dim)', marginBottom: 24 },
  h2: { fontSize: 16, fontWeight: 700, color: 'var(--bln-accent)', marginTop: 24, marginBottom: 8 },
  p: { fontSize: 14, color: 'var(--bln-text-muted)', margin: '8px 0' },
  ul: { fontSize: 14, color: 'var(--bln-text-muted)', paddingLeft: 20, margin: '8px 0' },
  link: { color: 'var(--bln-accent)', textDecoration: 'underline' },
}
